import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { db } from "../../../firebase";
import OfferPauseInsurance from "./OfferPauseInsurance";
import isADeviceCheck from "../../../utils/isADeviceCheck";

const landingId = "CF_OFFER_PAUSE";

const onLoad = async ({ session, landedAt, uid }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;
  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;

  const isADevice = isADeviceCheck(products[0].type);

  const userRef = doc(db, "users", uid);
  const docSnapshot = await getDoc(userRef);

  const { firstName } = docSnapshot.data();


  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    sessionID: session.sessionID,
    currentLanding: landingId,
    userName: firstName,
    isADevice,
    product: products[0]
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <OfferPauseInsurance state={state} setState={setState} />
);

const nextPage = async (props) =>
  `/formulario/cancelacion/lealtad?uid=${props.uid}`;
const prevPage = (props) => `/formulario/cancelacion/razon?uid=${props.uid}`;

const fieldsStructure = [];

const offerPauseInsuranceProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default offerPauseInsuranceProps;
